import { ClientUsersClient } from '@src/clientUser/manage/ClientUsersClient';
import { useMutation } from '@tanstack/react-query';

export const useDeactivateClientUser = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  const { mutate: deactivate, isPending: isDeactivating } = useMutation({
    mutationFn: ({
      clientUserId,
      clientId,
    }: {
      clientUserId: string;
      clientId: string;
    }) => ClientUsersClient.deactivate(clientUserId, clientId),
    onSuccess,
  });

  return {
    deactivate,
    isDeactivating,
  };
};
